import React, { memo, ReactNode } from "react";

import useWindowDimensions from "../../hooks/useWindowDimensions";

interface AdaptiveIconProps {
  sm: ReactNode;
  lg: ReactNode;
}

const AdaptiveIcon: React.FC<AdaptiveIconProps> = ({ sm, lg }) => {
  const { width } = useWindowDimensions();

  if (width >= 992) {
    return lg;
  }

  return sm;
};

export default memo(AdaptiveIcon);
